export const NOT_EMPTY = /^(?!\s*$).+/
export const COLLECTION_CODE_VALIDATION_RULE =/^[A-Za-z0-9]{4}_[A-Za-z0-9]{3}$/
export const ARTWORK_NAME_CODE_VALIDATION_RULE =/^[A-Za-z0-9]{3}_[A-Za-z0-9]{2}$/
export const ARTWORK_NUMBER_VALIDATION_RULE =/^([A-Za-z0-9]{4}_[A-Za-z0-9]{3})_([A-Za-z0-9]{3}_[A-Za-z0-9]{2})_(\d+)$/
// export const PRINTING_TECHNIQUE_VALIDATION_RULE =//